export default {
    antenatalCareTest: 'Antenatal Care Test',
    date: 'Date',
    gAByLMPWeek: 'GA Week',
    gAByLMPDay: 'GA Day',
    gABySonographyWeek: 'GA Sonography Week',
    gABySonographyDay: 'GA Sonography Day',
    bP: 'BP',
    description: 'Description',
    fundus: 'Fundus',
    fHR: 'FHR',
    fM: 'FM',
    oedema: 'Oedema'
}